import React, { useState } from 'react';
import styled from 'styled-components';
import { Col, Container, MainContainer, PageContainer, Row } from 'ui/layout';
import { BREAKPOINTS, COLORS } from 'utils';
import tabImg from 'assets/principles/tab.png';
import tabActiveImg1 from 'assets/principles/tab_active_1.png';
import tabActiveImg2 from 'assets/principles/tab_active_2.png';
import tabActiveImg3 from 'assets/principles/tab_active_3.png';
import tabActiveMob1 from 'assets/principles/tab1_active_mob.png';
import tabActiveMob2 from 'assets/principles/tab2_active_mob.png';
import tabActiveMob3 from 'assets/principles/tab3_active_mob.png';
import bg1 from 'assets/principles/bg1.png';
import bg2 from 'assets/principles/bg2.png';
import bg3 from 'assets/principles/bg3.png';
import bg2_tablet from 'assets/principles/bg2_tablet.png';
import figure from 'assets/principles/figure.svg';
import tabTablet from 'assets/principles/tab_tablet.png';
import { fontMagra, fontMontserrat } from 'ui';

const icon1 = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='52'
    height='50'
    viewBox='0 0 52 50'
    fill='none'
  >
    <path
      d='M43.6456 7.57368C42.7642 8.33331 41.8639 9.05496 41.0089 9.82978C39.5832 11.1155 38.1744 12.422 36.8655 13.8178C33.8841 16.9874 31.1043 20.3241 28.9158 24.1127C27.701 26.2017 26.6388 28.3857 25.925 30.7177C25.7612 31.2514 25.7518 31.2476 25.3807 30.8507C24.192 29.5841 22.8447 28.4791 21.3729 27.5634C21.2591 27.5026 21.1627 27.4134 21.0928 27.3044C21.0229 27.1953 20.9819 27.0701 20.9737 26.9405C20.7888 24.8689 21.1304 22.784 21.9662 20.8824C23.2695 17.7888 25.3826 15.2934 27.8272 13.0563C30.241 10.8748 32.8607 8.93676 35.6488 7.26982C38.7745 5.38682 42.0033 3.68378 45.3199 2.1689C46.8774 1.45105 48.4576 0.790169 50.0283 0.0932072C50.3711 -0.058719 50.5425 -0.0663154 50.6046 0.389463C50.8871 2.47845 51.1131 4.55034 51.2355 6.65642C51.3504 8.65995 51.4446 10.6635 51.39 12.667C51.2676 17.1393 50.825 21.568 49.4633 25.8599C48.6327 28.4578 47.5008 30.8925 45.802 33.0346C43.3744 36.0959 40.2066 37.8317 36.3852 38.4394C34.9256 38.6711 33.4641 38.5989 32.0008 38.6293C31.5657 38.6293 31.4357 38.4166 31.3698 38.0102C30.9498 35.0533 31.4339 32.1876 32.1966 29.3485C32.9858 26.4239 34.1591 23.6513 35.5132 20.9546C37.6983 16.6633 40.2174 12.5535 43.0467 8.66375C43.2802 8.3371 43.5043 8.00477 43.7341 7.67433L43.6456 7.57368Z'
      fill='white'
    />
    <path
      d='M7.70522 28.7052C8.94635 29.7725 10.1931 30.8321 11.423 31.9108C12.295 32.6705 13.15 33.4605 13.9975 34.2524C15.4477 35.6045 16.8433 37.0111 18.1842 38.4721C19.7953 40.2106 21.3147 42.033 22.7363 43.932C23.3164 44.7182 23.8664 45.5253 24.4427 46.3134C24.6555 46.6021 24.631 46.7863 24.3165 46.9781C22.0357 48.334 19.625 49.1886 16.9299 48.9664C14.9467 48.8031 13.2103 47.9998 11.6358 46.8186C9.31549 45.0809 7.62988 42.7906 6.17404 40.318C3.98181 36.6224 2.46193 32.6382 1.2095 28.5438C0.763139 27.0872 0.352566 25.6211 0.0418108 24.1284C-0.0580075 23.6441 -0.00338999 23.5682 0.474984 23.5587C5.21164 23.4504 9.90875 23.7695 14.5004 25.0381C17.8208 25.9572 20.9189 27.3625 23.565 29.63C26.7272 32.34 28.6765 35.7678 29.3564 39.9097C29.4373 40.3997 29.4901 40.8954 29.5447 41.3891C29.556 41.505 29.6012 41.6664 29.4844 41.7347C29.3677 41.8031 29.2754 41.6493 29.1906 41.5733C28.0606 40.5649 26.9118 39.5736 25.6989 38.662C23.4871 36.9952 21.1791 35.4625 18.7869 34.072C15.2967 32.0475 11.6793 30.2548 7.95759 28.7052C7.88979 28.6786 7.81822 28.6596 7.74853 28.6387L7.70522 28.7052Z'
      fill='white'
    />
  </svg>
);
const icon2 = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='48'
    height='46'
    viewBox='0 0 48 46'
    fill='none'
  >
    <path
      d='M0.0558638 19.0791C0.0558638 13.9401 0.0630258 8.80107 0.0444046 3.66061C0.0444046 3.14068 0.239212 2.7398 0.510652 2.35183C0.782093 1.96386 1.15523 1.65118 1.51978 1.34783C1.9495 0.989262 2.46374 0.885276 3.01593 0.865914C6.1178 0.757625 9.22039 0.7942 12.3223 0.771968C16.1761 0.742565 20.03 0.705991 23.8846 0.695951C27.023 0.689497 30.1629 0.678023 33.3034 0.734677C36.6201 0.7942 39.9376 0.753322 43.2543 0.806391C43.9333 0.817865 44.6151 0.851571 45.2919 0.870934C45.8233 0.885276 46.2509 1.15205 46.6448 1.46257C47.1626 1.87206 47.5974 2.36115 47.8803 2.96857C47.9455 3.10769 47.9347 3.24754 47.9354 3.38881C47.9416 10.8351 47.9486 18.2807 47.9562 25.7256C47.9562 26.8121 48.0214 27.9 47.9927 28.985C47.9369 31.0869 47.9505 33.1889 47.939 35.2908C47.9318 36.5437 47.3095 37.3361 46.2581 37.8876C45.9434 38.053 45.5921 38.1361 45.2368 38.1293C40.295 38.1211 35.3532 38.1194 30.4114 38.1242H29.9817C29.3199 38.1278 29.2519 38.2153 29.4144 38.8765C29.6758 39.9408 30.304 40.7604 31.1333 41.4453C32.02 42.1789 33.1029 42.4206 34.1843 42.6644C34.6692 42.7756 35.1276 42.9427 35.3876 43.4139C35.8445 44.2443 35.2493 45.2146 34.3075 45.2347C32.3022 45.2777 30.2985 45.299 28.2964 45.2985C26.4107 45.2985 24.5242 45.3121 22.6384 45.2713C19.5359 45.2046 16.434 45.2404 13.3314 45.2175C12.9504 45.2175 12.4949 44.6703 12.4476 44.164C12.3652 43.2848 12.7792 42.8394 13.7833 42.658C14.7874 42.4766 15.7887 42.2277 16.641 41.6167C17.7518 40.82 18.5253 39.8095 18.6463 38.3838C18.6657 38.1486 18.5998 38.1128 18.4114 38.1171C18.2438 38.1214 18.077 38.1171 17.9101 38.1171H2.64995C1.46105 38.1171 0.214861 36.9245 0.111011 35.7347C0 34.4568 0 33.1688 0 31.8794C0 27.6124 0 23.3456 0 19.0791H0.0558638ZM23.7428 3.50069V3.49352C18.8249 3.49352 13.907 3.49352 8.98906 3.49352C7.14125 3.49352 5.29274 3.48778 3.44708 3.61041C2.92998 3.64627 2.79319 3.78037 2.79319 4.28667C2.80322 12.8551 2.813 21.4237 2.82255 29.9926C2.82255 30.5297 2.94717 30.6645 3.48218 30.6832C4.23276 30.71 4.98357 30.7308 5.73463 30.7456C8.78924 30.8101 11.8438 30.7958 14.8977 30.8037C21.9165 30.8223 28.9353 30.8589 35.9491 30.7821C37.7747 30.7621 39.6017 30.7821 41.4273 30.7635C42.488 30.7542 43.5494 30.7198 44.6101 30.6782C45.1036 30.6588 45.2389 30.4982 45.2389 30.0227C45.2389 21.4543 45.2389 12.8857 45.2389 4.31679C45.2389 3.79687 45.1086 3.64196 44.6108 3.62117C43.515 3.57384 42.4185 3.50786 41.3227 3.50571C35.4632 3.4928 29.6033 3.49113 23.7428 3.50069ZM24.0508 36.5071C24.8701 36.5006 25.7854 35.5856 25.7496 34.7859C25.7024 33.7102 24.8809 32.9752 23.9398 32.9852C23.0646 32.9945 22.1994 33.8694 22.2424 34.7888C22.2861 35.7211 23.0051 36.4626 24.0508 36.5071Z'
      fill='#989898'
    />
    <path
      d='M34.528 10.0268C34.528 10.7669 34.5345 11.5077 34.5237 12.2499C34.5237 12.465 34.5954 12.5633 34.8052 12.6271C36.6222 13.1822 38.4356 13.7509 40.2483 14.311C40.431 14.3676 40.4833 14.4207 40.3995 14.633C39.6639 16.5047 38.2967 17.7109 36.456 18.4173C35.8208 18.6611 35.1447 18.6224 34.4779 18.6195C31.848 18.6059 30.0468 17.3043 28.9631 14.975C27.5973 12.0455 28.923 8.39528 31.8416 6.97534C32.6115 6.60099 33.4358 6.43318 34.2652 6.27469C34.518 6.22593 34.4578 6.43963 34.4614 6.55725C34.4894 7.46299 34.5065 8.37018 34.5244 9.27664C34.5295 9.52692 34.5244 9.77864 34.5244 10.0289L34.528 10.0268Z'
      fill='#989898'
    />
    <path
      d='M15.8282 18.7618C15.8282 16.9345 15.8146 15.1044 15.8325 13.28C15.8454 12.0157 15.9041 10.7521 15.9342 9.48845C15.9399 9.2518 16.0395 9.13777 16.2665 9.10908C17.1467 8.99793 18.0255 9.03737 18.9043 9.12414C19.127 9.14566 19.1958 9.29267 19.2001 9.49634C19.2072 9.86639 19.228 10.2364 19.2323 10.6065C19.2846 14.9409 19.3247 19.276 19.2667 23.6097C19.2473 25.0289 19.2731 26.4495 19.208 27.8695C19.1915 28.2281 19.0597 28.3471 18.7181 28.3593C17.9546 28.3873 17.1926 28.3837 16.4262 28.3729C16.0681 28.3672 15.9385 28.2295 15.9249 27.858C15.8067 24.8295 15.8225 21.7975 15.8282 18.7618Z'
      fill='#989898'
    />
    <path
      d='M21.4024 21.2829C21.4024 19.0727 21.3988 16.8625 21.4024 14.6522C21.4024 14.0907 21.4676 14.0384 22.0233 14.0391C22.7746 14.0391 23.5274 14.0513 24.2779 14.052C24.4763 14.052 24.5644 14.1129 24.5938 14.3317C24.6654 14.8437 24.6439 15.3572 24.6439 15.8685C24.6439 19.9067 24.636 23.9449 24.6439 27.9832C24.6439 28.2836 24.5659 28.3618 24.2694 28.3546C23.4352 28.3341 22.5996 28.3341 21.7626 28.3546C21.4697 28.3618 21.3809 28.2887 21.3823 27.9839C21.3959 25.75 21.3902 23.5154 21.3902 21.2815L21.4024 21.2829Z'
      fill='#989898'
    />
    <path
      d='M13.7087 21.6518V27.8507C13.7087 28.347 13.7087 28.3491 13.2288 28.3527C12.5126 28.357 11.7964 28.3664 11.0802 28.3527C10.5789 28.3463 10.5323 28.2982 10.5116 27.8005C10.3927 24.8997 10.4471 21.9981 10.4464 19.0966C10.4464 17.8194 10.4915 16.5429 10.4922 15.2656C10.4922 14.9379 10.5925 14.8353 10.9177 14.8454C11.7284 14.8683 12.5399 14.8597 13.3527 14.8576C13.6156 14.8576 13.718 14.9415 13.7159 15.2341C13.7015 17.3747 13.708 19.5133 13.7087 21.6518Z'
      fill='#989898'
    />
    <path
      d='M35.639 8.73708C35.639 7.81771 35.6476 6.89833 35.6333 5.97968C35.6333 5.72581 35.7121 5.65768 35.9585 5.66127C37.267 5.6835 38.3799 6.18908 39.3805 6.99945C40.2678 7.71659 40.9561 8.59222 41.33 9.67151C41.7418 10.8512 41.7969 12.0704 41.5549 13.2995C41.5148 13.5025 41.4045 13.5247 41.2147 13.4788C40.2199 13.2393 39.2587 12.8879 38.2782 12.6068C37.4797 12.378 36.6911 12.1127 35.8933 11.881C35.6935 11.8229 35.6326 11.7304 35.6347 11.5303C35.6433 10.5981 35.6383 9.66578 35.6383 8.73708H35.639Z'
      fill='#989898'
    />
    <path
      d='M8.33313 24.6893C8.34817 25.765 8.43698 26.8364 8.33313 27.9093C8.30019 28.2399 8.17485 28.374 7.84468 28.3682C7.03394 28.3532 6.2232 28.3438 5.41318 28.3582C5.1446 28.3625 5.07799 28.2865 5.07871 28.0204C5.08874 25.7887 5.07871 23.5569 5.07871 21.3252C5.07871 21.0742 5.09017 20.8232 5.07871 20.5729C5.06725 20.3642 5.14675 20.248 5.35445 20.248C6.26044 20.248 7.16644 20.248 8.07602 20.248C8.33815 20.248 8.33958 20.4173 8.33958 20.6066C8.33337 21.9687 8.33122 23.3296 8.33313 24.6893Z'
      fill='#989898'
    />
    <path
      d='M34.814 25.1227C32.5722 25.1227 30.3298 25.1156 28.0881 25.1306C27.7651 25.1306 27.73 25.0137 27.8016 24.762C27.8766 24.535 27.907 24.2956 27.8911 24.0571C27.8668 23.8046 27.9721 23.7401 28.2177 23.7422C30.8281 23.7652 33.4386 23.7814 36.0494 23.791C37.8507 23.7996 39.6512 23.8147 41.4517 23.8018C41.7984 23.8018 41.8886 23.9172 41.8607 24.2277C41.8442 24.4178 41.8213 24.62 41.8686 24.8015C41.9588 25.1421 41.7769 25.1292 41.5391 25.1285C39.2955 25.1218 37.0538 25.1199 34.814 25.1227Z'
      fill='#989898'
    />
    <path
      d='M34.9207 20.9304C37.1273 20.9304 39.3332 20.9354 41.5391 20.9246C41.8156 20.9246 41.9201 20.9856 41.8722 21.2739C41.8242 21.5622 41.9867 21.9501 41.7962 22.1402C41.5914 22.3438 41.2054 22.2083 40.9003 22.2119C36.6797 22.2377 32.4591 22.2542 28.2385 22.2886C27.9413 22.2886 27.8697 22.2069 27.894 21.9351C27.9227 21.6167 27.7644 21.2029 27.9506 21.0028C28.1368 20.8027 28.558 20.939 28.8752 20.9375C30.8906 20.9275 32.9053 20.9304 34.9207 20.9304Z'
      fill='#989898'
    />
    <path
      d='M32.86 28.0603C31.3202 28.0603 29.7803 28.0546 28.2412 28.0661C27.9827 28.0661 27.9025 28.0058 27.8831 27.734C27.8222 26.8204 27.8065 26.8075 28.7196 26.7171C29.1572 26.6734 29.6013 26.687 30.0425 26.687C32.5019 26.687 34.9606 26.6913 37.4193 26.6748C37.7588 26.6748 37.8534 26.7774 37.819 27.0936C37.7846 27.4099 37.9422 27.7978 37.761 27.9936C37.5798 28.1894 37.1744 28.056 36.8693 28.0575C35.5336 28.0646 34.1972 28.0603 32.86 28.0603Z'
      fill='#989898'
    />
  </svg>
);
const icon3 = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='54'
    height='52'
    viewBox='0 0 54 52'
    fill='none'
  >
    <path
      d='M8.17847 35.7103C7.89852 34.9565 7.6958 34.1762 7.57343 33.3814C7.34568 31.763 7.26957 30.1269 7.34609 28.4944C7.39263 26.9878 7.5072 25.4865 7.6504 23.9871C7.72917 23.1756 7.82941 22.364 7.89922 21.5507C7.91354 21.4092 7.9565 21.359 8.10687 21.3447C10.1921 21.152 12.2734 21.7531 13.9353 23.0282C15.5973 24.3033 16.7178 26.1585 17.0733 28.2238C17.2864 29.494 17.1807 30.7551 16.9803 32.0145C16.7422 33.4996 16.4092 34.9704 16.3144 36.477C16.1622 38.6277 16.6868 40.772 17.8144 42.6091C18.3027 43.4066 18.8578 44.1611 19.4738 44.8645C19.5311 44.9308 19.583 44.9989 19.6528 45.0938C19.1987 45.1129 18.7439 45.0961 18.2924 45.0437C16.2497 44.8904 14.2325 44.4947 12.2831 43.8649C9.33844 42.9047 6.67123 41.4662 4.48197 39.234C2.33389 37.0306 0.860656 34.4401 0.216229 31.418C-0.284991 29.0712 0.0694434 26.857 1.44422 24.8488C1.51356 24.7421 1.55084 24.6177 1.55162 24.4905C1.6757 21.8331 2.22321 19.2127 3.17343 16.7282C5.76546 10.0927 10.2937 5.27908 16.7583 2.28737C19.1355 1.18 21.6774 0.468399 24.2838 0.180636C31.5962 -0.62193 38.164 1.24296 43.8636 5.91325C48.627 9.815 51.6074 14.8418 52.8641 20.8754C53.3452 23.1801 53.4929 25.5421 53.3026 27.8888C52.8211 33.8991 50.562 39.1534 46.4825 43.5944C42.8783 47.5689 38.1142 50.3057 32.8672 51.4158C30.5962 51.9141 28.2673 52.095 25.9467 51.9533C25.1502 51.9067 24.3589 51.8225 23.5677 51.715C22.6082 51.5878 22.0838 50.6957 22.4686 49.8035C23.6805 46.9946 24.9067 44.1892 26.1186 41.3838C26.1991 41.2046 26.2815 41.2046 26.4426 41.2691C27.1031 41.5647 27.7655 41.8549 28.4349 42.1326C28.6301 42.2132 28.6659 42.2831 28.5781 42.4909C27.6234 44.6549 26.6813 46.822 25.7516 48.992C25.6317 49.2679 25.6335 49.2607 25.9414 49.2804C28.761 49.4713 31.5916 49.1384 34.2903 48.2987C38.0958 47.1186 41.5355 44.9818 44.2808 42.0923C47.0261 39.2029 48.9853 35.6573 49.9713 31.7942C50.7297 28.8414 50.8886 25.7663 50.4385 22.751C49.8461 18.6449 48.175 14.7698 45.5961 11.5217C43.0172 8.27352 39.6229 5.76877 35.7599 4.26333C33.745 3.46362 31.6216 2.97087 29.4606 2.80151C22.0408 2.22467 15.7487 4.68969 10.5951 10.0192C7.44991 13.2725 5.48799 17.185 4.60012 21.6206C4.35086 23.0057 4.30683 24.42 4.46944 25.8179C4.653 27.86 5.13551 29.8639 5.9015 31.7655C6.45778 33.1876 7.22542 34.5175 8.17847 35.7103Z'
      fill='#989898'
    />
    <path
      d='M28.4388 20.1479C28.7212 20.1474 28.9996 20.2137 29.2515 20.3414C33.5799 22.3884 37.9071 24.436 42.2331 26.4842C43.2177 26.9518 43.6491 27.955 43.3072 28.9242C43.2421 29.0833 43.1586 29.2342 43.0583 29.3738L35.4863 41.0916C35.4076 41.2135 35.327 41.3335 35.2554 41.4607C35.0229 41.9102 34.6215 42.249 34.1395 42.4025C33.6575 42.556 33.1343 42.5117 32.6849 42.2794C31.3477 41.6559 30.0177 41.0254 28.6841 40.3912C26.8761 39.5361 25.0681 38.681 23.2601 37.8258C22.1467 37.3009 21.7851 36.3604 22.1754 35.196C22.8144 33.2828 23.4105 31.3534 24.0245 29.4312C24.8718 26.7762 25.7179 24.1207 26.5628 21.4646C26.6886 21.07 26.9402 20.7276 27.279 20.4898C27.6178 20.2519 28.0253 20.1318 28.4388 20.1479ZM34.0561 38.374C34.0697 38.2085 34.0291 38.043 33.9402 37.9027C33.8514 37.7623 33.7192 37.6549 33.5638 37.5965L30.2736 36.0434L26.3212 34.1749C25.9291 33.9957 25.5604 34.0531 25.3456 34.354C25.2605 34.482 25.1874 34.6175 25.1272 34.7589C24.8605 35.3214 24.9947 35.6869 25.5514 35.9502L29.7975 37.9566C30.7802 38.4206 31.7666 38.881 32.7439 39.3468C33.05 39.4937 33.3508 39.5152 33.6014 39.2733C33.8416 39.0274 34.0004 38.7134 34.0561 38.374ZM36.1934 33.942C36.1992 33.7789 36.1537 33.6182 36.0635 33.4823C35.9733 33.3463 35.8428 33.2421 35.6904 33.1842C34.6343 32.6886 33.5781 32.1906 32.522 31.6902C31.1639 31.0488 29.8058 30.4075 28.4478 29.7662C28.0557 29.587 27.6816 29.6479 27.4722 29.9453C27.3884 30.0743 27.3159 30.2104 27.2556 30.352C26.9906 30.9127 27.1231 31.2728 27.6852 31.5397L31.4443 33.3132C32.59 33.8542 33.7356 34.3952 34.8813 34.9362C35.1874 35.0831 35.4917 35.0957 35.7387 34.8556C35.9761 34.602 36.1342 34.2844 36.1934 33.942ZM34.3317 25.7157C33.9814 25.7114 33.6376 25.8114 33.3441 26.003C33.0506 26.1946 32.8206 26.4691 32.6832 26.7917C32.5459 27.1143 32.5074 27.4704 32.5726 27.8149C32.6378 28.1595 32.8038 28.4769 33.0496 28.7268C33.2953 28.9768 33.6097 29.1481 33.9529 29.2189C34.2961 29.2898 34.6525 29.2571 34.9771 29.1249C35.3016 28.9926 35.5796 28.7669 35.7757 28.4764C35.9719 28.1858 36.0774 27.8435 36.0788 27.4928C36.0812 27.0257 35.8988 26.5766 35.5715 26.2437C35.2442 25.9107 34.7985 25.7209 34.3317 25.7157Z'
      fill='#989898'
    />
    <path
      d='M35.9106 11.863C36.0803 11.8564 36.2488 11.8947 36.3991 11.9738C36.5494 12.053 36.6763 12.1704 36.767 12.3141C36.8577 12.4578 36.909 12.6229 36.9158 12.7928C36.9225 12.9627 36.8846 13.1313 36.8056 13.2819C36.3116 14.3567 35.8032 15.4119 35.3002 16.476C34.611 17.9324 33.9164 19.3871 33.2434 20.8507C33.136 21.0836 33.0482 21.0854 32.8478 20.9833C32.4217 20.7647 31.9849 20.5676 31.5482 20.3688C31.4229 20.3115 31.3692 20.2649 31.4408 20.1126C32.6544 17.5521 33.8657 14.9909 35.0746 12.4291C35.1429 12.263 35.2586 12.1206 35.4073 12.0199C35.556 11.9193 35.7311 11.8647 35.9106 11.863Z'
      fill='#989898'
    />
    <path
      d='M43.6491 15.5869C44.5262 15.5869 44.9791 16.3035 44.6909 16.9574C44.4582 17.4948 44.1986 18.0054 43.9516 18.5303C42.9969 20.551 42.0422 22.5723 41.0875 24.5943C40.998 24.786 40.921 24.8182 40.7295 24.7197C40.3034 24.4993 39.8667 24.3005 39.4299 24.1052C39.2759 24.0371 39.2294 23.9762 39.3099 23.806C40.5164 21.2634 41.7182 18.7195 42.9151 16.1745C43.1031 15.7893 43.3985 15.5869 43.6491 15.5869Z'
      fill='#989898'
    />
  </svg>
);

const headers = [
  {
    icon: icon1,
    title: 'Экология и охрана\nокружающей среды',
    headerBg: tabActiveImg1,
    mobBg: tabActiveMob1
  },
  {
    icon: icon2,
    title: 'Современные\n программные комплексы',
    headerBg: tabActiveImg2,
    mobBg: tabActiveMob2
  },
  {
    icon: icon3,
    title: 'Технологии\n энергосбережения',
    headerBg: tabActiveImg3,
    mobBg: tabActiveMob3
  }
];

export const Tabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  if (headers) {
    return (
      <Container>
        <MainContainer>
          <Header>
            <Row nowrap>
              {headers.map((item, key) => (
                <TabCol
                  width={`${100 / headers.length}%`}
                  index={
                    activeTab === key
                      ? headers.length + 1
                      : activeTab === 0
                      ? headers.length - key
                      : key
                  }
                  active={activeTab === key}
                  key={key}
                >
                  <Tab
                    active={activeTab === key}
                    index={key}
                    onClick={() => setActiveTab(key)}
                  >
                    <Row
                      gap={7}
                      smGap={5}
                      alignCenter
                      justifyContent={'center'}
                      nowrap
                      height={'100%'}
                    >
                      {/*{item.icon && <IconWrapper>{item.icon}</IconWrapper>}*/}
                      <Title>{item.title}</Title>
                    </Row>
                  </Tab>
                </TabCol>
              ))}
            </Row>
          </Header>
        </MainContainer>

        <TabSlide visible={activeTab === 0}>
          <MainContainer>
            <TextRow alignCenter paddingBottom={15}>
              <Row gap={30} lgGap={20}>
                <Col
                  width={'50%'}
                  lgWidth={'100%'}
                  lgMarginTop={45}
                  smdMarginTop={'0'}
                >
                  <Text>
                    Скрупулезное соответствие проектов требованиям Министерства
                    природных ресурсов и экологии РФ. При строительстве дорог ГК
                    «Альянс» обязательно предусматривает наличие экодуков двух
                    типов: подземных и наземных переходов, что позволяет бережно
                    относится к фауне прилегающих территорий.
                    <br />
                    <br />
                    Строительство и содержание дорог — это сложный комплекс
                    работ, в котором охрана окружающей среды является жизненно
                    важным фактором. ГК «Альянс» внимательно относится к
                    вопросам экологии, осознавая ответственность перед будущими
                    поколениями, а потому разрабатывает и бережно воплощает
                    проекты повышения экологической безопасности в сфере
                    дорожного хозяйства.
                  </Text>
                </Col>
                <Col
                  width={'50%'}
                  lgWidth={'100%'}
                  lgMarginTop={20}
                  smdMarginTop={26}
                >
                  <Container>
                    <Text>
                      При производстве строительно-монтажных работ Компания,
                      действуя в строгом соответствии с существующими
                      нормативами в области экологии, гарантирует:
                    </Text>
                    <Ul>
                      <li>экономное потребление природных ресурсов;</li>
                      <li>
                        повторное использование строительных материалов и
                        утилизацию отходов;
                      </li>
                      <li>
                        организацию экологически безопасного производственного
                        процесса и автотранспортных перевозок.
                      </li>
                      <li>
                        использование технологии производства, позволяющие
                        значительно сократить выбросы СО2.
                      </li>
                    </Ul>
                  </Container>
                </Col>
              </Row>
            </TextRow>
          </MainContainer>

          <PageContainer lgMarginTop={50} smdMarginTop={-2}>
            <Bg bg={bg1} tab={1}>
              <BgTextContainer>
                <BgText>
                  Компания поддерживает принципы циркуляционной экономики, при
                  которой
                </BgText>
                <BgLine>
                  <BgText>
                    до 25% асфальтобетонного покрытия используется повторно,
                  </BgText>
                </BgLine>
                <BgText>
                  в максимальной степени стремится сохранить баланс
                  экономических, экологических и социальных факторов, соблюдая
                  интересы государства, населения, заказчиков, компании.
                </BgText>
                {icon1}
              </BgTextContainer>
            </Bg>
          </PageContainer>
        </TabSlide>

        <TabSlide visible={activeTab === 1}>
          <MainContainer>
            <TextRow
              alignCenter
              paddingTop={115}
              paddingBottom={70}
              lgPaddingTop={92}
              lgPaddingBottom={30}
            >
              <Row gap={30}>
                <Col width={'50%'} lgWidth={'100%'}>
                  <Container smMarginRight={-6}>
                    <Text>
                      Использование программного комплекса «Суприм» - это
                      передовой подход к управлению предприятием, который дает
                      возможность осуществить интегрирование компании в цифровую
                      экономику и обеспечивает полный контроль над бизнесом.
                      <br />
                      <br />
                      Методология СУПРИМ® и разработанные на ее основе
                      инструменты позволяют получать объективную и достоверную
                      информацию о ходе реализации текущего проекта,
                      расходовании ресурсов, а также с высокой долей
                      достоверности оценивать рентабельность проектов уже на
                      этапе инициации.
                    </Text>
                    <SvgWrapper>{icon2}</SvgWrapper>
                  </Container>
                </Col>
                <Col width={'50%'} lgWidth={'100%'} lgMarginTop={24}>
                  <Text>
                    Программный комплекс «Суприм» — это:
                    <br />
                    <br />— Контроль удаленных объектов.
                    <br />— Строительство без срыва сроков и не освоения
                    бюджетных денег.
                    <br />— Управление изменениями.
                    <br />— Работа в формате интерактивного мониторинга, с
                    учетом показателей план-факт отклонения от проектного
                    графика и принятие своевременных мер по учету этих данных.
                    <br />— Экспертная независимость
                    <br />— Выявление «слабых мест» и скрытых резервов экономии.
                    В ходе нормирования становятся очевидными участки
                    производственного процесса, в которых ресурсы используются
                    недостаточно эффективно, и наоборот.
                    <br />— ВСЕ полученные данные позволяют выбрать оптимальное
                    направление для движения вперед.
                  </Text>
                </Col>
              </Row>

              <SvgWrapperMob>{icon2}</SvgWrapperMob>
            </TextRow>
          </MainContainer>

          <PageContainer marginTop={50} lgMarginTop={'0'}>
            <Bg bg={bg2} tab={2}>
              <Figure2 src={figure} />
            </Bg>
          </PageContainer>
        </TabSlide>

        <TabSlide visible={activeTab === 2}>
          <MainContainer>
            <TextRow
              alignCenter
              justifyContent={'center'}
              paddingBottom={'0'}
              paddingTop={45}
              lgPaddingTop={22}
              smdPaddingBottom={17}
            >
              <Tab3Container maxWidth={784} textCenter marginRight={45}>
                <Text>
                  Строительство объектов социальной инфраструктуры диктует
                  высокие требования по внедрению технологий энергосбережения.
                  Все объекты, которые строит ГК «Альянс», можно назвать
                  энергоемкими: при строительстве используются датчики
                  мониторинга освещения, светодиодные решения, автоматизация
                  управления процессами.
                </Text>
                <SvgWrapper2>{icon3}</SvgWrapper2>
              </Tab3Container>
            </TextRow>
          </MainContainer>

          <PageContainer lgMarginTop={13} smdMarginTop={'0'}>
            <Bg bg={bg3}>
              <Figure3 src={figure} />
            </Bg>
          </PageContainer>
        </TabSlide>
      </Container>
    );
  }

  return null;
};

const Header = styled.div`
  border-bottom: 1px solid ${COLORS.lightGray};
  padding-left: 55px;
  padding-right: 120px;
  margin-left: -67px;
  margin-right: -68px;
  @media (max-width: ${BREAKPOINTS.xl}px) {
    padding-right: 88px;
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    margin-left: -60px;
    margin-right: -60px;
    padding-left: 80px;
    padding-right: 80px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    margin: 0 -23px;
    padding-left: 43px;
    padding-right: 1px;
  }
`;
const IconWrapper = styled.div`
  @media (max-width: ${BREAKPOINTS.xl}px) {
    > svg {
      width: 38px;
      max-height: 59px;
      margin-top: 3px;
    }
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    > svg {
      width: 24px;
      max-height: 37px;
      margin-top: 5px;
    }
  }
`;
const Title = styled.p`
  ${fontMagra}
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 35px;
  white-space: pre-line;
  @media (max-width: ${BREAKPOINTS.xl}px) {
    font-size: 18px;
    line-height: 25px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    font-size: 12px;
    line-height: 16px;
  }
`;
const TabCol = styled(Col)`
  ${(p) => `
  -webkit-tap-highlight-color:  rgba(255, 255, 255, 0); 
  z-index: ${p.index ? p.index : '0'};
  ${p.active ? 'pointer-events: none;' : ''}
  @media (max-width: ${BREAKPOINTS.lg}px) {
    margin-left: -20px;
    width: 100%;
    max-width: ${p.active ? '100%' : '130px'};
  } 
  @media (max-width: ${BREAKPOINTS.smd}px) {
    margin-left: -41px;
    max-width: ${p.active ? '100%' : '88px'};
  } 
`}
`;
const Tab = styled(Container)`
  height: 91px;
  margin-right: -66px;
  cursor: pointer;

  @media (max-width: ${BREAKPOINTS.xl}px) {
    margin-right: -50px;
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    height: 59px;
    margin: 0;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    height: 37px;
  }

  ${(p) =>
    p.active
      ? `
    pointer-events: none;
    background: url(" ${
      p.index ? headers[p.index].headerBg : headers[0].headerBg
    }") center/100% 100% no-repeat;
    ${Title} {
      color: ${COLORS.white};
    }
    ${IconWrapper} svg > * {
      fill: ${COLORS.white};
    }
    @media (max-width: ${BREAKPOINTS.lg}px) {
     ${
       p.index === 1
         ? `
      padding-left: 15px;
     `
         : ''
     }
     ${
       p.index >= 1
         ? `
      margin-left: -14px;
      margin-right: -14px;
     `
         : ''
     }
     @media (max-width: ${BREAKPOINTS.smd}px) {
      background-image: url("${
        p.index ? headers[p.index].mobBg : headers[0].mobBg
      }");
      margin: 0;
      padding: 0;
     }
    }
  `
      : `
    background: url("${tabImg}") center/100% 100% no-repeat;
     ${Title} {
      color: #989898;
    }
     ${IconWrapper} svg > * {
      fill:  #989898;
    }
    
    @media (max-width: ${BREAKPOINTS.lg}px) {
      width: 100%;
      background-image: url("${tabTablet}");
      ${Title} {
        display: none;
      }
    }
  `}
`;

const Text = styled.p`
  ${fontMontserrat}
`;

const TabSlide = styled.div`
  ${(p) => (p.visible ? 'display: block;' : 'display: none;')}
  @media (max-width: ${BREAKPOINTS.md}px) {
    font-size: 16px;
    line-height: 21px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    font-size: 12px;
    line-height: 16px;
  }
`;
const TextRow = styled(Row)`
  min-height: 431px;
  padding: 40px 0;
  ${(p) => (p.paddingBottom ? `padding-bottom: ${p.paddingBottom}px;` : '')}
  ${(p) => (p.paddingTop ? `padding-top: ${p.paddingTop}px;` : '')}
  @media (max-width: ${BREAKPOINTS.lg}px) {
    ${(p) =>
      p.lgPaddingBottom ? `padding-bottom: ${p.lgPaddingBottom}px;` : ''}
    ${(p) => (p.lgPaddingTop ? `padding-top: ${p.lgPaddingTop}px;` : '')}
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    padding: 23px 5px 0 0;
    ${(p) =>
      p.smdPaddingBottom ? `padding-bottom: ${p.smdPaddingBottom}px;` : ''}
    min-height: 223px;
  }
`;
const Ul = styled.ul`
  padding-left: 28px;
  margin: 22px 0 0 0;
  > li {
    margin-bottom: 20px;
    ${fontMontserrat}
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    padding-left: 20px;
    margin: 10px 0 0 0;
    > li {
      margin-bottom: 21px;
    }
  }
`;
const Bg = styled.div`
  height: 631px;
  position: relative;
  overflow: hidden;
  background: url('${(p) => p.bg}') center/cover no-repeat;

  @media (max-width: ${BREAKPOINTS.xl}px) {
    ${(p) =>
      p.tab === 1
        ? `
      background-size: 1600px 631px;
      background-position: calc(100% + 75px) 51%;
    `
        : ''}
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    ${(p) =>
      p.tab === 2
        ? `
      background-image: url("${bg2_tablet}");
    `
        : ''}
  }
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: 486px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    height: 229px;
    ${(p) =>
      p.tab === 1
        ? `
      height: 223px;
      background-size: 732px 288px;
      background-position: 100% 51%;
    `
        : ''}
  }
`;
const BgTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 699px;
  background: rgba(118, 61, 14, 0.5);
  margin-left: auto;
  padding: 0 120px 45px 44px;
  color: #ffffff;
  position: relative;
  > svg {
    content: '';
    position: absolute;
    left: calc(50% - 50px);
    bottom: 80px;
    transform: translateX(-50%);
    width: 51px;
    height: 49px;
  }
  :after {
    content: '';
    position: absolute;
    right: -168px;
    top: 139px;
    background: url('${figure}') top/contain no-repeat;
    width: 288px;
    height: 256px;
  }

  @media (max-width: ${BREAKPOINTS.md}px) {
    font-size: 22px;
    line-height: 28px;
    padding-top: 74px;
    max-width: 696px;
    :after {
      top: 104px;
      right: -172px;
    }
    > svg {
      display: none;
    }
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    padding: 18px 41px 0 19px;
    max-width: 351px;
    width: 96%;
    font-size: 12px;
    line-height: 16px;
    :after {
      top: 48px;
      right: -97px;
      width: 131px;
    }
  }
`;
const BgLine = styled.div`
  background: #a76c3b;
  margin: 10px -21px 9px -44px;
  padding: 13px 0 13px 44px;
  font-size: 25px;
  line-height: 32px;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    font-size: 31px;
    line-height: 40px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    font-size: 12px;
    line-height: 16px;
    margin: 12px -18px 10px -19px;
    padding: 8px 40px 9px 18px;
  }
`;
const BgText = styled.div`
  max-width: 402px;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    max-width: unset;
  }
`;
const Tab3Container = styled(Container)`
  @media (max-width: ${BREAKPOINTS.lg}px) {
    text-align: left;
    margin: 0;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    margin: 0 -2px;
  }
`;
const Figure2 = styled.img`
  position: absolute;
  top: -91px;
  right: 187px;
  width: 288px;
  height: 256px;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    right: 16px;
    top: -96px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    right: 6px;
    top: -113px;
    width: 135px;
  }
`;
const Figure3 = styled(Figure2)`
  top: 50%;
  left: -8px;
  right: unset;
  transform: translate(-50%, -50%);
  @media (max-width: ${BREAKPOINTS.lg}px) {
    top: unset;
    bottom: 20px;
    left: -5px;
    transform: translate(-50%, 0%);
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    bottom: -58px;
    left: -2px;
  }
`;

const SvgWrapper = styled.div`
  margin-top: 60px;
  text-align: center;

  * {
    fill: #989898;
  }

  @media (max-width: ${BREAKPOINTS.lg}px) {
    display: none;
  }
`;
const SvgWrapperMob = styled(SvgWrapper)`
  display: none;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    display: block;
    width: 100%;
    margin-top: 49px;
    margin-left: -8px;
    > svg {
      width: 40px;
    }
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    margin-top: 7px;
    margin-left: 0;
    > svg {
      width: 23px;
    }
  }
`;
const SvgWrapper2 = styled.div`
  margin-top: 50px;

  * {
    fill: #4b4a54;
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    text-align: center;
    margin-top: 70px;
    margin-left: -14px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    > svg {
      width: 35px;
    }
    margin-top: 30px;
    margin-left: 6px;
  }
`;
